let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fnxSZ")).then(() => parcelRequire('5zGnG'));